"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusEnum = exports.UserRoleEnum = exports.UserContactTypeEnum = exports.ScanCenterCodeEnum = exports.ReturnsIntervalEnum = exports.AlarmStateEnum = exports.AlarmTypeEnum = void 0;
var AlarmTypeEnum;
(function (AlarmTypeEnum) {
    AlarmTypeEnum["WORKFLOW_CONNECTOR_BROKEN"] = "WORKFLOW_CONNECTOR_BROKEN";
    AlarmTypeEnum["WORKFLOW_RECIPE_MISCONFIGURED"] = "WORKFLOW_RECIPE_MISCONFIGURED";
})(AlarmTypeEnum || (exports.AlarmTypeEnum = AlarmTypeEnum = {}));
var AlarmStateEnum;
(function (AlarmStateEnum) {
    AlarmStateEnum["OPEN"] = "OPEN";
    AlarmStateEnum["RESOLVED"] = "RESOLVED";
})(AlarmStateEnum || (exports.AlarmStateEnum = AlarmStateEnum = {}));
var ReturnsIntervalEnum;
(function (ReturnsIntervalEnum) {
    ReturnsIntervalEnum["BI_WEEKLY"] = "BI_WEEKLY";
    ReturnsIntervalEnum["DAILY"] = "DAILY";
    ReturnsIntervalEnum["HALF_YEARLY"] = "HALF_YEARLY";
    ReturnsIntervalEnum["MONTHLY"] = "MONTHLY";
    ReturnsIntervalEnum["QUARTERLY"] = "QUARTERLY";
    ReturnsIntervalEnum["WEEKLY"] = "WEEKLY";
    ReturnsIntervalEnum["YEARLY"] = "YEARLY";
})(ReturnsIntervalEnum || (exports.ReturnsIntervalEnum = ReturnsIntervalEnum = {}));
var ScanCenterCodeEnum;
(function (ScanCenterCodeEnum) {
    ScanCenterCodeEnum["ATOS"] = "ATOS";
    ScanCenterCodeEnum["IAB"] = "IAB";
    ScanCenterCodeEnum["ODS"] = "ODS";
    ScanCenterCodeEnum["SPS"] = "SPS";
    ScanCenterCodeEnum["SRZ"] = "SRZ";
})(ScanCenterCodeEnum || (exports.ScanCenterCodeEnum = ScanCenterCodeEnum = {}));
var UserContactTypeEnum;
(function (UserContactTypeEnum) {
    UserContactTypeEnum["CONTAINER_RECIPIENT"] = "ContainerRecipient";
    UserContactTypeEnum["CUSTOMER"] = "Customer";
})(UserContactTypeEnum || (exports.UserContactTypeEnum = UserContactTypeEnum = {}));
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["ADMIN"] = "Admin";
    UserRoleEnum["MEMBER"] = "Member";
    UserRoleEnum["OWNER"] = "Owner";
})(UserRoleEnum || (exports.UserRoleEnum = UserRoleEnum = {}));
var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum["ACTIVE"] = "Active";
    UserStatusEnum["DEACTIVATED"] = "Deactivated";
    UserStatusEnum["INVITED"] = "Invited";
})(UserStatusEnum || (exports.UserStatusEnum = UserStatusEnum = {}));
//# sourceMappingURL=account.js.map